<template>
    <b-table head-variant="dark"
             :thead-class="head_class"
             :tbody-tr-class="rowClass"
             :busy="is_load"
             striped
             class="table-responsive-xl resolution_table"
             :items="items"
             :fields="fields">
        
        <template slot="thead-top" slot-scope="data" v-if="!show_head">
            <tr class="info">
                <td colspan="6" class="title_type">{{title}}</td>
            </tr>
        </template>
        
        <div slot="table-busy" class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Завантаження...</strong>
        </div>
        
        <template  v-slot:cell(cur_action)="data">
            <span v-html="data.value"></span>
        </template>
        
        <template  v-slot:cell(name)="data"  >
            <div class="u_fio">{{data.item.name}}</div>
            <vacation :id=parseInt(data.item.user_id)></vacation>
        </template>
        
        
        <template  v-slot:cell(user_image)="data" >
            <img :src="data.item.user_image" class="user_avatar rounded-circle pointer" v-if="data.item.hasOwnProperty('user_image')"
                 @click="click_photo(data.item.user_id)
            "/>
        </template>
        
        
        <template   v-slot:cell(cur_right)="data">
            <div class="big_click"  @click="data.toggleDetails" v-if="is_edit(data.item)">
                <fa :icon="faTools"  />
            </div>
        </template>
        
        <template  v-slot:cell(act_date)="data">
            <div v-html="data.value"></div>
            <doc_watch :u_type="type" :doc_id="parseInt(data.item.mem_id)" :user_id="parseInt(data.item.user_id)"></doc_watch>
        </template>
        
        
        <template  v-slot:row-details="row" >
            <b-card>
                <admineditor :row="row.item"></admineditor>
            </b-card>
        </template>
    
    </b-table>
</template>

<script>

import Fa from 'vue-fa'
import admineditor from './admineditor.vue'
import { faTools } from '@fortawesome/free-solid-svg-icons'
import doc_watch from "../doc_watch/doc_watch.vue";
import vacation from "../../../../../../../shared/user/user_block/vacation.vue";

import {mapGetters} from "vuex";

export default {
    name: "r_table",
    
    components : {
        Fa,
        doc_watch,
        admineditor,
        vacation,
    },
    
    props: {
        items: {
            type: Array,
            required: true
        },
        
        type : {
            type : String,
            required: true
        },
        
        is_load  : {
            type : Boolean,
            required: true
        },
        
        title : {
            type : String,
            required: true
        },
        
        show_head : {
            type : Boolean,
            default:false
        }
    },
    
    data() {
        return {
            faTools,
            fields : [
                {
                    key : 'user_image',
                    label: ' ',
                    class:'user_td_logo'
                },
                
                {
                    key : 'name',
                    label: 'ПІБ',
                    class:'user_td_name'
                },
                
                {
                    key : 'cur_action',
                    label :'Резолюцiя'
                    
                },
                
                {
                    key : 'act_date',
                    label :'Дата',
                    class : 'date_d',
                },
                
                {
                    key : 'time_diff',
                    label :'Час обробки',
                    class : 'user_time',
                },
                
                {
                    key : 'cur_right',
                    label :'Редагування',
                    class : 'admedit',
                    _showDetails:true,
                },
            
            ],
        }
    },
    
    
    computed: {
        
        ...mapGetters({
            'memorandum': "memorandum_inside/getMemorandum",
            'can_adm_show' : "memorandum_inside/getAdmRights",
            'is_mem_load': "memorandum_inside/is_load"
        }),
        
        head_class() {
            // if(!this.show_head) {
            return 'hidden_header';
            // }
        }
    },
    
    
    methods: {
        
        click_photo(userid) {
            EventBus.$emit("click_user_photo",userid);
        },
        
        is_edit(item) {
            if (myapp_config.debugState)
                console.log("%c|___cur_right", "color: #ffc241",item);
            
            if (item.cur_right !== undefined && item.cur_right != null && item.cur_right.length > 0) {
                if (this.can_adm_show) {
                    return true;
                } else {
                    return false;
                }
            }
            return false;
        },
        
        rowClass(item) {
            if (!item) return
            if (item.class === 'info') return 'table-info'
            if (item.class === 'success') return 'success'
            if (item.class === 'error') return 'error'
            if (item.class === 'hidden') return 'd-none'
        }
        
    },
    
}
</script>

<style scoped>




</style>
